import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66b29eae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "me-3 fs_14 text-muted"
}
const _hoisted_6 = {
  key: 0,
  class: "badge bg-info ms-1"
}
const _hoisted_7 = {
  key: 1,
  class: "badge bg-secondary ms-1"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_10 = { class: "d-flex align-items-center justify-content-between mb-4 p-3 bg-light rounded" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "me-2" }
const _hoisted_15 = { class: "badge bg-primary ms-2" }
const _hoisted_16 = { class: "badge bg-info ms-1" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "card-body"
}
const _hoisted_20 = { class: "field-grid section-grid" }
const _hoisted_21 = { class: "field-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Section ID", -1))
const _hoisted_23 = ["onUpdate:modelValue", "disabled"]
const _hoisted_24 = { class: "field-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Title (EN)", -1))
const _hoisted_26 = ["onUpdate:modelValue", "disabled"]
const _hoisted_27 = { class: "field-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Title (IT)", -1))
const _hoisted_29 = ["onUpdate:modelValue", "disabled"]
const _hoisted_30 = { class: "field-group" }
const _hoisted_31 = { class: "field-label" }
const _hoisted_32 = ["onUpdate:modelValue", "disabled"]
const _hoisted_33 = { class: "field-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Red Flags", -1))
const _hoisted_35 = ["onUpdate:modelValue", "disabled"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_40 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_41 = { class: "fs_14" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = { class: "me-2" }
const _hoisted_46 = { class: "badge bg-secondary me-1" }
const _hoisted_47 = {
  key: 0,
  class: "badge bg-warning text-dark me-1"
}
const _hoisted_48 = {
  key: 1,
  class: "text-muted fs_12 text-truncate ms-2",
  style: {"max-width":"400px"}
}
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "expand-icon" }
const _hoisted_52 = {
  key: 0,
  class: "question-body"
}
const _hoisted_53 = { class: "row mb-3" }
const _hoisted_54 = { class: "col-sm-4" }
const _hoisted_55 = { class: "field-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Question ID", -1))
const _hoisted_57 = ["onUpdate:modelValue", "disabled"]
const _hoisted_58 = { class: "col-sm-4" }
const _hoisted_59 = { class: "field-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Order", -1))
const _hoisted_61 = ["onUpdate:modelValue", "disabled"]
const _hoisted_62 = { class: "col-sm-4" }
const _hoisted_63 = ["for"]
const _hoisted_64 = ["id", "checked", "onChange", "disabled"]
const _hoisted_65 = { class: "row mb-3" }
const _hoisted_66 = { class: "col-sm-6" }
const _hoisted_67 = { class: "field-group field-grow" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Text (EN)", -1))
const _hoisted_69 = ["onUpdate:modelValue", "disabled"]
const _hoisted_70 = { class: "col-sm-6" }
const _hoisted_71 = { class: "field-group field-grow" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Text (IT)", -1))
const _hoisted_73 = ["onUpdate:modelValue", "disabled"]
const _hoisted_74 = { class: "row mb-3" }
const _hoisted_75 = { class: "col-sm-3" }
const _hoisted_76 = { class: "field-group" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Type", -1))
const _hoisted_78 = ["onUpdate:modelValue", "disabled"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Yes/No/Partially", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Yes/No", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "Informational", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 3 }, "Cert. Checklist", -1))
const _hoisted_83 = [
  _hoisted_79,
  _hoisted_80,
  _hoisted_81,
  _hoisted_82
]
const _hoisted_84 = { class: "col-sm-3" }
const _hoisted_85 = { class: "field-group" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Red Flag", -1))
const _hoisted_87 = ["onUpdate:modelValue", "disabled"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "None", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Red Flag", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "High Red Flag", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 3 }, "Reverse High RF", -1))
const _hoisted_92 = [
  _hoisted_88,
  _hoisted_89,
  _hoisted_90,
  _hoisted_91
]
const _hoisted_93 = { class: "col-sm-3" }
const _hoisted_94 = { class: "field-group" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Evidence", -1))
const _hoisted_96 = ["onUpdate:modelValue", "disabled"]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_99 = [
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = { class: "col-sm-3" }
const _hoisted_101 = { class: "field-group" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Required", -1))
const _hoisted_103 = ["onUpdate:modelValue", "disabled"]
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_106 = [
  _hoisted_104,
  _hoisted_105
]
const _hoisted_107 = { class: "file-upload-setting" }
const _hoisted_108 = { class: "field-group" }
const _hoisted_109 = { class: "field-label" }
const _hoisted_110 = ["onUpdate:modelValue", "disabled"]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_113 = [
  _hoisted_111,
  _hoisted_112
]
const _hoisted_114 = { class: "field-group" }
const _hoisted_115 = { class: "field-label" }
const _hoisted_116 = ["onUpdate:modelValue", "disabled"]
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_119 = [
  _hoisted_117,
  _hoisted_118
]
const _hoisted_120 = { class: "file-upload-hint" }
const _hoisted_121 = {
  key: 0,
  class: "sub-questions-area"
}
const _hoisted_122 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sub-questions-title" }, "SUB-QUESTIONS", -1))
const _hoisted_124 = ["onClick"]
const _hoisted_125 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_126 = { class: "fw_700 fs_12" }
const _hoisted_127 = ["onClick"]
const _hoisted_128 = { class: "field-grid sub-text-grid mb-2" }
const _hoisted_129 = { class: "field-group" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Sub ID", -1))
const _hoisted_131 = ["onUpdate:modelValue", "disabled"]
const _hoisted_132 = { class: "field-group" }
const _hoisted_133 = ["for"]
const _hoisted_134 = ["checked", "onChange", "disabled"]
const _hoisted_135 = { class: "field-group field-grow" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Text (EN)", -1))
const _hoisted_137 = ["onUpdate:modelValue", "disabled"]
const _hoisted_138 = { class: "field-group field-grow" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Text (IT)", -1))
const _hoisted_140 = ["onUpdate:modelValue", "disabled"]
const _hoisted_141 = { class: "row" }
const _hoisted_142 = { class: "col-sm-4" }
const _hoisted_143 = { class: "field-group" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Type", -1))
const _hoisted_145 = ["onUpdate:modelValue", "disabled"]
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Yes/No/P", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Yes/No", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "Info", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 3 }, "Cert.", -1))
const _hoisted_150 = [
  _hoisted_146,
  _hoisted_147,
  _hoisted_148,
  _hoisted_149
]
const _hoisted_151 = { class: "col-sm-4" }
const _hoisted_152 = { class: "field-group" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Red Flag", -1))
const _hoisted_154 = ["onUpdate:modelValue", "disabled"]
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "None", -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Red Flag", -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "High RF", -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 3 }, "Rev HRF", -1))
const _hoisted_159 = [
  _hoisted_155,
  _hoisted_156,
  _hoisted_157,
  _hoisted_158
]
const _hoisted_160 = { class: "col-sm-4" }
const _hoisted_161 = { class: "field-group" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Evidence", -1))
const _hoisted_163 = ["onUpdate:modelValue", "disabled"]
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_166 = [
  _hoisted_164,
  _hoisted_165
]
const _hoisted_167 = { class: "row" }
const _hoisted_168 = { class: "col-sm-4" }
const _hoisted_169 = { class: "field-group" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Score group", -1))
const _hoisted_171 = ["onUpdate:modelValue", "disabled"]
const _hoisted_172 = { class: "col-sm-4" }
const _hoisted_173 = { class: "field-group" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Tier rank", -1))
const _hoisted_175 = ["onUpdate:modelValue", "disabled"]
const _hoisted_176 = { class: "file-upload-setting sub" }
const _hoisted_177 = { class: "field-group" }
const _hoisted_178 = { class: "field-label" }
const _hoisted_179 = ["onUpdate:modelValue", "disabled"]
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_182 = [
  _hoisted_180,
  _hoisted_181
]
const _hoisted_183 = { class: "field-group" }
const _hoisted_184 = { class: "field-label" }
const _hoisted_185 = ["onUpdate:modelValue", "disabled"]
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Yes", -1))
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: false }, "No", -1))
const _hoisted_188 = [
  _hoisted_186,
  _hoisted_187
]
const _hoisted_189 = {
  key: 1,
  class: "sub-questions-area"
}
const _hoisted_190 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary me-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/due-diligence'))),
          "aria-label": _ctx.$localizationService.getLocalizedValue('Back to list', 'Back to list')
        }, " ← ", 8, _hoisted_3),
        _createVNode(_component_localized_text, {
          type: 'h1',
          localizedKey: "Survey Template",
          text: "Survey Template",
          class: "mb-0"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.template.version)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createTextVNode(" v" + _toDisplayString(_ctx.template.version) + " ", 1),
              (_ctx.isCustom)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Custom",
                      text: "Custom"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Default",
                      text: "Default"
                    })
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isCustom && _ctx.canEdit)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-outline-warning me-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetToDefault()))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Reset to Default",
                text: "Reset to Default"
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.canEdit)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn btn-tertiary",
              disabled: _ctx.saving,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save()))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Save",
                text: "Save"
              })
            ], 8, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Total Section Weights",
                  text: "Total Section Weights"
                }),
                _createTextVNode(": ")
              ]),
              _createElementVNode("span", {
                class: _normalizeClass([_ctx.totalWeight == 100 ? 'text-success' : 'text-danger', "fw_700 ms-2"])
              }, _toDisplayString(_ctx.totalWeight) + " / 100 ", 3)
            ]),
            _createElementVNode("div", null, [
              (_ctx.canEdit)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-sm btn-primary me-2",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addSection()))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Add Section",
                      text: "Add Section"
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/due-diligence')))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Back to list",
                  text: "Back to list"
                })
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.template.sections, (section, sIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-4",
              key: section.sectionId
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "card-header d-flex align-items-center justify-content-between",
                  onClick: ($event: any) => (_ctx.toggleSection(sIdx))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("strong", _hoisted_14, _toDisplayString(section.sectionId), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.getSectionTitle(section)), 1),
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Weight",
                        text: "Weight"
                      }),
                      _createTextVNode(": " + _toDisplayString(section.weight), 1)
                    ]),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(section.questions.length) + " Q ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.canEdit)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-sm btn-outline-danger me-2",
                          onClick: _withModifiers(($event: any) => (_ctx.removeSection(sIdx)), ["stop"])
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Remove",
                            text: "Remove"
                          })
                        ], 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.expandedSections[sIdx] ? '▲' : '▼'), 1)
                  ])
                ], 8, _hoisted_12),
                (_ctx.expandedSections[sIdx])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.sectionId) = $event),
                            disabled: !_ctx.canEdit
                          }, null, 8, _hoisted_23), [
                            [_vModelText, section.sectionId]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.title.values['en-US']) = $event),
                            disabled: !_ctx.canEdit
                          }, null, 8, _hoisted_26), [
                            [_vModelText, section.title.values['en-US']]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.title.values['it-IT']) = $event),
                            disabled: !_ctx.canEdit
                          }, null, 8, _hoisted_29), [
                            [_vModelText, section.title.values['it-IT']]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("label", _hoisted_31, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Weight",
                              text: "Weight"
                            })
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.weight) = $event),
                            min: "0",
                            max: "100",
                            disabled: !_ctx.canEdit
                          }, null, 8, _hoisted_32), [
                            [
                              _vModelText,
                              section.weight,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select form-select-sm",
                            "onUpdate:modelValue": ($event: any) => ((section.hasRedFlags) = $event),
                            disabled: !_ctx.canEdit,
                            style: {"height":"31px"}
                          }, _hoisted_38, 8, _hoisted_35), [
                            [_vModelSelect, section.hasRedFlags]
                          ])
                        ])
                      ]),
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("strong", _hoisted_41, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Questions",
                            text: "Questions"
                          })
                        ]),
                        (_ctx.canEdit)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-sm btn-primary",
                              onClick: ($event: any) => (_ctx.addQuestion(section))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Add Question",
                                text: "Add Question"
                              })
                            ], 8, _hoisted_42))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.questions, (question, qIdx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "question-card",
                          key: question.questionId
                        }, [
                          _createElementVNode("div", {
                            class: "question-header",
                            onClick: ($event: any) => (_ctx.toggleQuestion(sIdx, qIdx))
                          }, [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("strong", _hoisted_45, _toDisplayString(question.questionId), 1),
                              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.getQuestionTypeLabel(question.questionType)), 1),
                              (question.redFlagType > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.getRedFlagLabel(question.redFlagType)), 1))
                                : _createCommentVNode("", true),
                              (!_ctx.isQuestionExpanded(sIdx, qIdx))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.getQuestionText(question)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              (_ctx.canEdit)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-sm btn-outline-danger me-2",
                                    onClick: _withModifiers(($event: any) => (_ctx.removeQuestion(section, qIdx)), ["stop"])
                                  }, "×", 8, _hoisted_50))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.isQuestionExpanded(sIdx, qIdx) ? '▲' : '▼'), 1)
                            ])
                          ], 8, _hoisted_43),
                          (_ctx.isQuestionExpanded(sIdx, qIdx))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _hoisted_56,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control form-control-sm",
                                        "onUpdate:modelValue": ($event: any) => ((question.questionId) = $event),
                                        disabled: !_ctx.canEdit
                                      }, null, 8, _hoisted_57), [
                                        [_vModelText, question.questionId]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("div", _hoisted_59, [
                                      _hoisted_60,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "form-control form-control-sm",
                                        "onUpdate:modelValue": ($event: any) => ((question.sortOrder) = $event),
                                        min: "0",
                                        disabled: !_ctx.canEdit
                                      }, null, 8, _hoisted_61), [
                                        [
                                          _vModelText,
                                          question.sortOrder,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("label", {
                                      class: "field-label",
                                      for: 'scored_' + question.questionId,
                                      style: {"display":"block"}
                                    }, "Scored", 8, _hoisted_63),
                                    _createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      id: 'scored_' + question.questionId,
                                      checked: question.weight > 0,
                                      onChange: ($event: any) => (question.weight = ($event.target as HTMLInputElement).checked ? 1 : 0),
                                      disabled: !_ctx.canEdit,
                                      style: {"display":"block","height":"31px","width":"31px"}
                                    }, null, 40, _hoisted_64)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_65, [
                                  _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("div", _hoisted_67, [
                                      _hoisted_68,
                                      _withDirectives(_createElementVNode("textarea", {
                                        class: "form-control form-control-sm",
                                        rows: "4",
                                        "onUpdate:modelValue": ($event: any) => ((question.text.values['en-US']) = $event),
                                        disabled: !_ctx.canEdit
                                      }, null, 8, _hoisted_69), [
                                        [_vModelText, question.text.values['en-US']]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, [
                                      _hoisted_72,
                                      _withDirectives(_createElementVNode("textarea", {
                                        class: "form-control form-control-sm",
                                        rows: "4",
                                        "onUpdate:modelValue": ($event: any) => ((question.text.values['it-IT']) = $event),
                                        disabled: !_ctx.canEdit
                                      }, null, 8, _hoisted_73), [
                                        [_vModelText, question.text.values['it-IT']]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("div", _hoisted_76, [
                                      _hoisted_77,
                                      _withDirectives(_createElementVNode("select", {
                                        class: "form-select form-select-sm",
                                        "onUpdate:modelValue": ($event: any) => ((question.questionType) = $event),
                                        disabled: !_ctx.canEdit
                                      }, _hoisted_83, 8, _hoisted_78), [
                                        [
                                          _vModelSelect,
                                          question.questionType,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("div", _hoisted_85, [
                                      _hoisted_86,
                                      _withDirectives(_createElementVNode("select", {
                                        class: "form-select form-select-sm",
                                        "onUpdate:modelValue": ($event: any) => ((question.redFlagType) = $event),
                                        disabled: !_ctx.canEdit
                                      }, _hoisted_92, 8, _hoisted_87), [
                                        [
                                          _vModelSelect,
                                          question.redFlagType,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_93, [
                                    _createElementVNode("div", _hoisted_94, [
                                      _hoisted_95,
                                      _withDirectives(_createElementVNode("select", {
                                        class: "form-select form-select-sm",
                                        "onUpdate:modelValue": ($event: any) => ((question.hasEvidenceField) = $event),
                                        disabled: !_ctx.canEdit
                                      }, _hoisted_99, 8, _hoisted_96), [
                                        [_vModelSelect, question.hasEvidenceField]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_100, [
                                    _createElementVNode("div", _hoisted_101, [
                                      _hoisted_102,
                                      _withDirectives(_createElementVNode("select", {
                                        class: "form-select form-select-sm",
                                        "onUpdate:modelValue": ($event: any) => ((question.isRequired) = $event),
                                        disabled: !_ctx.canEdit
                                      }, _hoisted_106, 8, _hoisted_103), [
                                        [_vModelSelect, question.isRequired]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_107, [
                                  _createElementVNode("div", _hoisted_108, [
                                    _createElementVNode("label", _hoisted_109, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Allow File Upload",
                                        text: "Allow File Upload"
                                      })
                                    ]),
                                    _withDirectives(_createElementVNode("select", {
                                      class: "form-select form-select-sm",
                                      "onUpdate:modelValue": ($event: any) => ((question.allowFileUpload) = $event),
                                      disabled: !_ctx.canEdit,
                                      style: {"max-width":"160px"}
                                    }, _hoisted_113, 8, _hoisted_110), [
                                      [_vModelSelect, question.allowFileUpload]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_114, [
                                    _createElementVNode("label", _hoisted_115, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Certificate document",
                                        text: "Certificate document"
                                      })
                                    ]),
                                    _withDirectives(_createElementVNode("select", {
                                      class: "form-select form-select-sm",
                                      "onUpdate:modelValue": ($event: any) => ((question.isCertificateDocument) = $event),
                                      disabled: !_ctx.canEdit,
                                      style: {"max-width":"160px"}
                                    }, _hoisted_119, 8, _hoisted_116), [
                                      [_vModelSelect, question.isCertificateDocument]
                                    ])
                                  ]),
                                  _createElementVNode("span", _hoisted_120, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Let suppliers attach a document to this answer. Does not affect scoring.",
                                      text: "Let suppliers attach a document to this answer. Does not affect scoring."
                                    })
                                  ])
                                ]),
                                (question.subQuestions && question.subQuestions.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                      _createElementVNode("div", _hoisted_122, [
                                        _hoisted_123,
                                        (_ctx.canEdit)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "btn btn-sm btn-outline-primary",
                                              onClick: ($event: any) => (_ctx.addSubQuestion(question))
                                            }, "+", 8, _hoisted_124))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.subQuestions, (sub, subIdx) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "sub-question-item",
                                          key: sub.subQuestionId
                                        }, [
                                          _createElementVNode("div", _hoisted_125, [
                                            _createElementVNode("span", _hoisted_126, _toDisplayString(sub.subQuestionId), 1),
                                            (_ctx.canEdit)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "btn btn-sm btn-outline-danger",
                                                  onClick: ($event: any) => (_ctx.removeSubQuestion(question, subIdx))
                                                }, "×", 8, _hoisted_127))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_128, [
                                            _createElementVNode("div", _hoisted_129, [
                                              _hoisted_130,
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                "onUpdate:modelValue": ($event: any) => ((sub.subQuestionId) = $event),
                                                disabled: !_ctx.canEdit
                                              }, null, 8, _hoisted_131), [
                                                [_vModelText, sub.subQuestionId]
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_132, [
                                              _createElementVNode("label", {
                                                class: "field-label",
                                                for: 'scored_' + question.questionId,
                                                style: {"display":"block"}
                                              }, "Scored", 8, _hoisted_133),
                                              _createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                checked: sub.weight > 0,
                                                onChange: ($event: any) => (sub.weight = ($event.target as HTMLInputElement).checked ? 1 : 0),
                                                disabled: !_ctx.canEdit,
                                                style: {"display":"block","height":"31px","width":"31px"}
                                              }, null, 40, _hoisted_134)
                                            ]),
                                            _createElementVNode("div", _hoisted_135, [
                                              _hoisted_136,
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                "onUpdate:modelValue": ($event: any) => ((sub.text.values['en-US']) = $event),
                                                disabled: !_ctx.canEdit
                                              }, null, 8, _hoisted_137), [
                                                [_vModelText, sub.text.values['en-US']]
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_138, [
                                              _hoisted_139,
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                "onUpdate:modelValue": ($event: any) => ((sub.text.values['it-IT']) = $event),
                                                disabled: !_ctx.canEdit
                                              }, null, 8, _hoisted_140), [
                                                [_vModelText, sub.text.values['it-IT']]
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_141, [
                                            _createElementVNode("div", _hoisted_142, [
                                              _createElementVNode("div", _hoisted_143, [
                                                _hoisted_144,
                                                _withDirectives(_createElementVNode("select", {
                                                  class: "form-select form-select-sm",
                                                  "onUpdate:modelValue": ($event: any) => ((sub.questionType) = $event),
                                                  disabled: !_ctx.canEdit
                                                }, _hoisted_150, 8, _hoisted_145), [
                                                  [
                                                    _vModelSelect,
                                                    sub.questionType,
                                                    void 0,
                                                    { number: true }
                                                  ]
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_151, [
                                              _createElementVNode("div", _hoisted_152, [
                                                _hoisted_153,
                                                _withDirectives(_createElementVNode("select", {
                                                  class: "form-select form-select-sm",
                                                  "onUpdate:modelValue": ($event: any) => ((sub.redFlagType) = $event),
                                                  disabled: !_ctx.canEdit
                                                }, _hoisted_159, 8, _hoisted_154), [
                                                  [
                                                    _vModelSelect,
                                                    sub.redFlagType,
                                                    void 0,
                                                    { number: true }
                                                  ]
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_160, [
                                              _createElementVNode("div", _hoisted_161, [
                                                _hoisted_162,
                                                _withDirectives(_createElementVNode("select", {
                                                  class: "form-select form-select-sm",
                                                  "onUpdate:modelValue": ($event: any) => ((sub.hasEvidenceField) = $event),
                                                  disabled: !_ctx.canEdit
                                                }, _hoisted_166, 8, _hoisted_163), [
                                                  [_vModelSelect, sub.hasEvidenceField]
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_167, [
                                            _createElementVNode("div", _hoisted_168, [
                                              _createElementVNode("div", _hoisted_169, [
                                                _hoisted_170,
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "text",
                                                  class: "form-control form-control-sm",
                                                  "onUpdate:modelValue": ($event: any) => ((sub.scoreGroup) = $event),
                                                  disabled: !_ctx.canEdit,
                                                  placeholder: "(none)"
                                                }, null, 8, _hoisted_171), [
                                                  [_vModelText, sub.scoreGroup]
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_172, [
                                              _createElementVNode("div", _hoisted_173, [
                                                _hoisted_174,
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "number",
                                                  min: "0",
                                                  class: "form-control form-control-sm",
                                                  "onUpdate:modelValue": ($event: any) => ((sub.scoreGroupRank) = $event),
                                                  disabled: !_ctx.canEdit
                                                }, null, 8, _hoisted_175), [
                                                  [
                                                    _vModelText,
                                                    sub.scoreGroupRank,
                                                    void 0,
                                                    { number: true }
                                                  ]
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_176, [
                                            _createElementVNode("div", _hoisted_177, [
                                              _createElementVNode("label", _hoisted_178, [
                                                _createVNode(_component_localized_text, {
                                                  localizedKey: "Allow File Upload",
                                                  text: "Allow File Upload"
                                                })
                                              ]),
                                              _withDirectives(_createElementVNode("select", {
                                                class: "form-select form-select-sm",
                                                "onUpdate:modelValue": ($event: any) => ((sub.allowFileUpload) = $event),
                                                disabled: !_ctx.canEdit,
                                                style: {"max-width":"140px"}
                                              }, _hoisted_182, 8, _hoisted_179), [
                                                [_vModelSelect, sub.allowFileUpload]
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_183, [
                                              _createElementVNode("label", _hoisted_184, [
                                                _createVNode(_component_localized_text, {
                                                  localizedKey: "Certificate document",
                                                  text: "Certificate document"
                                                })
                                              ]),
                                              _withDirectives(_createElementVNode("select", {
                                                class: "form-select form-select-sm",
                                                "onUpdate:modelValue": ($event: any) => ((sub.isCertificateDocument) = $event),
                                                disabled: !_ctx.canEdit,
                                                style: {"max-width":"140px"}
                                              }, _hoisted_188, 8, _hoisted_185), [
                                                [_vModelSelect, sub.isCertificateDocument]
                                              ])
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_189, [
                                      (_ctx.canEdit)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-sm btn-outline-secondary",
                                            onClick: ($event: any) => (_ctx.addSubQuestion(question))
                                          }, [
                                            _createVNode(_component_localized_text, {
                                              localizedKey: "Add Sub-Question",
                                              text: "Add Sub-Question"
                                            })
                                          ], 8, _hoisted_190))
                                        : _createCommentVNode("", true)
                                    ]))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}